module.exports = __webpack_public_path__ + "static/media/inovacao_tendencia.de199c47.png";